/**
 * Creates a custom event listener for deleting an entry.
 */
export function deleteEntryListener() {
	$( document ).on( 'deleteEntry', function updateTable( event, data ) {
		window.mce = 'mce' in window ? window.mce : {};
		$.ajax({
			url: `${ window.mce.api_url }ime-entry`,
			data: {
				action: data.action,
				data: data.entryId,
			},
			success: function() {
				if ( data.redirect ) {
					window.location = data.redirect;
				}
			}
		});
	});
}

/**
 * Deletes the entry from IME Form page.
 */
export function deleteEntryFromForm() {
	const $formContainer = $( '.o__ime-form-header' );
	if ( !$formContainer.length ) {
		return;
	}

	const entryId = $formContainer.data( 'entry-id' );
	const action = $formContainer.data( 'delete-action' );

	$( '.confirm-cancel-button' ).on( 'click', function onDelete() {
		const data = {
			action,
			entryId,
		};
		$( document ).trigger( 'deleteEntry', data );
	});
}